import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../app-settings';
import { catchError, map, throwError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TicketsEventService {

  constructor(private http: HttpClient) {}

  checkCartBonds() {
    const work_time_cash_register_id = localStorage.getItem('id_work_time');
    const url = `${AppSettings.API_URI_V2}/cash-register/cart/${work_time_cash_register_id}/validate`;
    return this.http
      .get<any>(url)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(err => { return throwError(() => err); })
      );
  }

  getTicketsBySessionSeat(idSession: number, idSeat: number) {
    const url = `${AppSettings.API_URI_V2}/admin/tickets/session/${idSession}/seat/${idSeat}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  validateSeatsInBatch(sessionId: number, seatIds: number[], ticketId: number): Observable<any> {
    const url = `${AppSettings.API_URI_V2}/admin/tickets/session/${sessionId}/seats/validate-batch`;
    return this.http.post<any>(url, {
      seat_ids: seatIds,
      ticket_id: ticketId
    }).pipe(
      map((data) => {
        return data;
      }),
      catchError(err => { return throwError(() => err); })
    );
  }
}
